<template>
    <div class="btn-container" @click="onClick">
        <span>
            {{text}}
            <md-icon v-if="materialIconName" class="btn-icon" style="fill: red;">
                {{ materialIconName }}
            </md-icon>
        </span>
    </div>
</template>

<script>
export default {
  name: 'Btn',
  props: ['text', 'materialIconName'],
  methods: {
    onClick() {
      this.$emit('click');
    },
  },
};
</script>

<style src="./Button.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/Button/Button.vue